module.exports = __webpack_public_path__ + "static/img/PFKCarousel1.0986e38.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PFKCarousel1.jpg
// module id = 250
// module chunks = 1